import { diContainer } from '../../../libs/container';
import { LocalStorage, NAVIGATION_DROPDOWN_STATES } from '../../../util/LocalStorage';
import { IDropdownStorageState, INavigationItem } from './navigation.slice';

const localStorage = diContainer.get(LocalStorage);
const storageState = localStorage.get(NAVIGATION_DROPDOWN_STATES);

const DEFAULT_MEMBER_STORAGE_DROPDOWN: IDropdownStorageState = {
    ptoAndLeave: false,
};

const parsedStorageState: IDropdownStorageState = storageState ? JSON.parse(storageState) : DEFAULT_MEMBER_STORAGE_DROPDOWN;

export const MEMBER_NAVIGATION: INavigationItem[] = [
    {
        keyTitle: 'dashboard',
        url: '/',
        icon: '/svg/sidebar/dashboard.svg',
        activeIcon: '/svg/sidebar/dashboard-bold.svg',
        iconAlt: 'Dashboard',
        subMenuItems: [],
        hasParams: false,
        sectionTitle: '',
        disabled: false,
    },
    {
        keyTitle: 'timeTracking',
        url: '/time-tracking',
        icon: '/svg/sidebar/timer-start.svg',
        activeIcon: '/svg/sidebar/timer-start-bold.svg',
        iconAlt: 'Clock',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: '',
        disabled: false,
    },
    {
        keyTitle: 'ptoAndLeave',
        url: '',
        icon: '/svg/sidebar/leave-request.svg',
        activeIcon: '/svg/sidebar/leave-request-bold.svg',
        iconAlt: 'Calendar',
        subMenuItems: [
            {
                keyTitle: 'myBalance',
                url: '/my-balance',
                hasParams: false,
            },
            {
                keyTitle: 'calendar',
                url: '/calendar',
                hasParams: false,
            },
            {
                keyTitle: 'holidays',
                url: '/holidays',
                hasParams: false,
                disabled: false,
            },
        ],
        hasParams: false,
        sectionTitle: '',
        disabled: false,
        showDropdown: parsedStorageState['ptoAndLeave'],
    },
    {
        keyTitle: 'projects',
        url: '/projects',
        icon: '/svg/sidebar/projects.svg',
        activeIcon: '/svg/sidebar/projects-bold.svg',
        iconAlt: 'Projects',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'manage',
        disabled: false,
    },
    {
        keyTitle: 'integrations',
        url: '/integrations',
        icon: '/svg/sidebar/share.svg',
        activeIcon: '/svg/sidebar/share-bold.svg',
        iconAlt: 'Organization',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'manage',
        disabled: false,
    },
    // {
    //     keyTitle: 'reports',
    //     url: '/reports',
    //     icon: '/svg/sidebar/directbox-notif.svg',
    //     activeIcon: '/svg/sidebar/clients-bold.svg',
    //     iconAlt: 'Suitcase',
    //     subMenuItems: [],
    //     hasParams: true,
    //     sectionTitle: 'manage',
    //     disabled: true,
    // },
    {
        keyTitle: 'teams',
        url: '/teams',
        icon: '/svg/sidebar/teams.svg',
        activeIcon: '/svg/sidebar/teams-bold.svg',
        iconAlt: 'Organization',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'organization',
        disabled: false,
    },
    {
        keyTitle: 'performance',
        url: '/organization',
        icon: '/svg/sidebar/chart.svg',
        activeIcon: '/svg/sidebar/chart-bold.svg',
        iconAlt: 'Performance',
        subMenuItems: [
            {
                keyTitle: 'evaluation',
                url: '/evaluation',
                hasParams: false,
            },
        ],
        hasParams: true,
        sectionTitle: 'organization',
        disabled: false,
        showDropdown: parsedStorageState['settings'],
    },
];
